import { render, staticRenderFns } from "./run-index.vue?vue&type=template&id=2bd2db58&scoped=true"
import script from "./run-index.vue?vue&type=script&lang=js"
export * from "./run-index.vue?vue&type=script&lang=js"
import style0 from "./run-index.vue?vue&type=style&index=0&id=2bd2db58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2db58",
  null
  
)

export default component.exports